<template>
  <div class="nav-footer">
    <!-- 电影胶片装饰 -->
    <div class="film-strip top-strip"></div>
    
    <!-- 定宽布局 -->
    <div class="container">
      <!-- 品牌信息 -->
      <div class="footer-brand">
        <div class="brand-logo">
          <div class="logo-icon"></div>
          <div class="brand-text">
            <h3>首都电影院</h3>
            <p>CAPITAL CINEMA</p>
          </div>
        </div>
        <p class="brand-desc">始于1937年，中国电影放映界的一面旗帜。我们致力于传承电影文化，为影迷提供卓越的观影体验。</p>
        <div class="brand-features">
          <div class="feature-item">
            <div class="feature-icon premium-icon"></div>
            <span>VIP尊享服务</span>
          </div>
          <div class="feature-item">
            <div class="feature-icon tech-icon"></div>
            <span>先进放映技术</span>
          </div>
          <div class="feature-item">
            <div class="feature-icon service-icon"></div>
            <span>贴心客户服务</span>
          </div>
        </div>
      </div>

      <!-- 联系方式 -->
      <div class="f-info">
        <h2 class="section-title">
          <div class="title-icon contact-icon"></div>
          联系我们
          <div class="title-decoration"></div>
        </h2>
        <ul>
          <li class="contact-item">
            <div class="item-icon company-icon"></div>
            <span>北京首都华融影院有限责任公司</span>
          </li>
          <li class="contact-item">
            <div class="item-icon phone-icon"></div>
            <span>服务热线：010-66062266-506</span>
          </li>
          <li class="contact-item">
            <div class="item-icon website-icon"></div>
            <span>官方网站：shoududianyingyuan.cn</span>
          </li>
          <li class="contact-item">
            <div class="item-icon address-icon"></div>
            <span>影院地址：北京市西城区金融街街道西单北大街西单大悦城10层</span>
          </li>
          <li class="contact-item">
            <div class="item-icon time-icon"></div>
            <span>营业时间：09:00 - 次日02:00</span>
          </li>
        </ul>
      </div>
    
      <!-- 导航栏 -->
      <div class="f-list">
        <h2 class="section-title">
          <div class="title-icon nav-icon"></div>
          快速导航
          <div class="title-decoration"></div>
        </h2>
        <ul>
          <li class="nav-item">
            <a href="javascript:;" @click="gohome()">
              <div class="nav-dot"></div>
              网站首页
            </a>
          </li>
          <li class="nav-item">
            <a href="javascript:;" @click="goAc2()">
              <div class="nav-dot"></div>
              行业资讯
            </a>
          </li>
          <li class="nav-item">
            <a href="javascript:;" @click="goInfo()">
              <div class="nav-dot"></div>
              关于我们
            </a>
          </li>
          <li class="nav-item">
            <a href="javascript:;" @click="goLogin()">
              <div class="nav-dot"></div>
              会员登录
            </a>
          </li>
          <li class="nav-item">
            <a href="javascript:;" @click="goRegister()">
              <div class="nav-dot"></div>
              会员注册
            </a>
          </li>
          <li class="nav-item">
            <a href="javascript:;" @click="goXy()">
              <div class="nav-dot"></div>
              用户协议
            </a>
          </li>
        </ul>

        <!-- 特色服务 -->
        <div class="footer-services">
          <h3 class="services-title">特色服务</h3>
          <div class="services-list">
            <span class="service-tag">IMAX影厅</span>
            <span class="service-tag">杜比全景声</span>
            <span class="service-tag">4K激光放映</span>
            <span class="service-tag">VIP包厢</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 版权信息 -->
    <div class="footer-bottom">
      <div class="container">
        <div class="copyright">
          <p>&copy; 2025 北京首都华融影院有限责任公司 版权所有</p>
          <div class="bottom-links">
            <a href="javascript:;" @click="goXy()">用户协议</a>
            <span class="separator">|</span>
            <a href="https://beian.miit.gov.cn/#/Integrated/index" class="icp-link">
              京ICP备08004964号
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "nav-footer",
  methods: {
    // 登录时隐藏逻辑
    logged() {
      if (this.state == "0") {
        this.LoggedShow = false;
      }
    },
    // 登录跳转
    goLogin() {
      this.$router.push("/login");
    },
    // 注册跳转
    goRegister() {
      this.$router.push("/register");
    },
    // 退出登录
    tolg() {
      window.localStorage.setItem("state", "10");
      this.LoggedShow = true;
      location.reload();
    },
    // 跳转最新文章
    goAc1() {
      this.$router.push("/ac1");
    },
    // 跳转行业资讯
    goAc2() {
      this.$router.push("/ac2");
    },
    // 跳转独加新闻
    goAc3() {
      this.$router.push("/ac3");
    },
    // 跳转关于我们
    goInfo() {
      this.$router.push("/info");
    },
    // 跳转注册协议
    goXy() {
      this.$router.push("/agreement");
    },
    gohome() {
      this.$router.push("/");
    },
    // 显示隐私政策
    showPrivacy() {
      alert("隐私政策内容...");
    },
    // 显示免责声明
    showDisclaimer() {
      alert("免责声明内容...");
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.nav-footer {
  width: 100%;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  position: relative;
  overflow: hidden;

  // 电影胶片装饰
  .film-strip {
    position: absolute;
    left: 0;
    width: 100%;
    height: 20px;
    background: repeating-linear-gradient(
      90deg,
      #000 0px,
      #000 10px,
      #ffd700 10px,
      #ffd700 20px,
      #000 20px,
      #000 30px
    );
    opacity: 0.3;

    &.top-strip {
      top: 0;
    }
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 60px 20px 40px;
    display: grid;
    grid-template-columns: 1.5fr 1.2fr 1fr;
    gap: 50px;
    align-items: start;

    // 品牌信息
    .footer-brand {
      .brand-logo {
        display: flex;
        align-items: center;
        gap: 15px;
        margin-bottom: 20px;

        .logo-icon {
          width: 60px;
          height: 60px;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ffd700'%3E%3Cpath d='M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z'/%3E%3C/svg%3E");
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }

        .brand-text {
          h3 {
            font-size: 28px;
            font-weight: bold;
            color: #ffd700;
            margin: 0 0 5px 0;
            background: linear-gradient(135deg, #ffd700, #ffed4e);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }

          p {
            font-size: 14px;
            color: rgba(255, 255, 255, 0.7);
            letter-spacing: 2px;
            margin: 0;
          }
        }
      }

      .brand-desc {
        font-size: 15px;
        color: rgba(255, 255, 255, 0.7);
        line-height: 1.7;
        margin-bottom: 25px;
        text-align: justify;
      }

      .brand-features {
        display: flex;
        flex-direction: column;
        gap: 15px;

        .feature-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px 15px;
          background: rgba(255, 215, 0, 0.1);
          border-radius: 10px;
          border: 1px solid rgba(255, 215, 0, 0.2);
          transition: all 0.3s ease;

          &:hover {
            background: rgba(255, 215, 0, 0.15);
            transform: translateX(5px);
          }

          .feature-icon {
            width: 24px;
            height: 24px;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;

            &.premium-icon {
              background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ffd700'%3E%3Cpath d='M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z'/%3E%3C/svg%3E");
            }

            &.tech-icon {
              background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ffd700'%3E%3Cpath d='M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z'/%3E%3C/svg%3E");
            }

            &.service-icon {
              background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ffd700'%3E%3Cpath d='M2 6H0v5h.01L0 20c0 1.1.9 2 2 2h18v-2H2V6zm20-2h-8l-2-2H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 15l4.5-6 3.5 4.51 2.5-3.01L21 15H7z'/%3E%3C/svg%3E");
            }
          }

          span {
            font-size: 14px;
            color: rgba(255, 255, 255, 0.9);
            font-weight: 500;
          }
        }
      }
    }

    // 通用标题样式
    .section-title {
      font-size: 20px;
      font-weight: bold;
      color: #ffd700;
      margin-bottom: 25px;
      display: flex;
      align-items: center;
      gap: 12px;

      .title-icon {
        width: 24px;
        height: 24px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;

        &.contact-icon {
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ffd700'%3E%3Cpath d='M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z'/%3E%3C/svg%3E");
        }

        &.nav-icon {
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ffd700'%3E%3Cpath d='M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z'/%3E%3C/svg%3E");
        }
      }

      .title-decoration {
        flex: 1;
        height: 2px;
        background: linear-gradient(90deg, #ffd700, transparent);
        margin-left: 10px;
        border-radius: 1px;
      }
    }

    // 联系方式
    .f-info {
      ul {
        list-style: none;
        padding: 0;
        margin: 0;

        .contact-item {
          display: flex;
          align-items: flex-start;
          gap: 15px;
          margin-bottom: 20px;
          color: rgba(255, 255, 255, 0.8);
          font-size: 15px;
          line-height: 1.6;

          .item-icon {
            width: 18px;
            height: 18px;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
            flex-shrink: 0;
            margin-top: 2px;

            &.company-icon {
              background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ffd700'%3E%3Cpath d='M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z'/%3E%3C/svg%3E");
            }

            &.phone-icon {
              background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ffd700'%3E%3Cpath d='M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z'/%3E%3C/svg%3E");
            }

            &.website-icon {
              background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ffd700'%3E%3Cpath d='M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z'/%3E%3C/svg%3E");
            }

            &.address-icon {
              background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ffd700'%3E%3Cpath d='M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z'/%3E%3C/svg%3E");
            }

            &.time-icon {
              background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ffd700'%3E%3Cpath d='M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z'/%3E%3C/svg%3E");
            }
          }
        }
      }
    }

    // 导航栏
    .f-list {
      ul {
        list-style: none;
        padding: 0;
        margin: 0 0 30px 0;

        .nav-item {
          margin-bottom: 12px;

          a {
            display: flex;
            align-items: center;
            gap: 15px;
            color: rgba(255, 255, 255, 0.8);
            text-decoration: none;
            font-size: 15px;
            transition: all 0.3s ease;
            padding: 8px 0;

            &:hover {
              color: #ffd700;
              transform: translateX(5px);

              .nav-dot {
                background-color: #ffd700;
                transform: scale(1.2);
              }
            }

            .nav-dot {
              width: 6px;
              height: 6px;
              background-color: rgba(255, 255, 255, 0.5);
              border-radius: 50%;
              transition: all 0.3s ease;
            }
          }
        }
      }

      // 特色服务
      .footer-services {
        .services-title {
          font-size: 16px;
          color: #ffd700;
          margin-bottom: 15px;
          font-weight: 600;
        }

        .services-list {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;

          .service-tag {
            background: rgba(255, 215, 0, 0.1);
            color: #ffd700;
            padding: 6px 12px;
            border-radius: 15px;
            font-size: 12px;
            border: 1px solid rgba(255, 215, 0, 0.3);
            transition: all 0.3s ease;

            &:hover {
              background: rgba(255, 215, 0, 0.2);
              transform: translateY(-2px);
            }
          }
        }
      }
    }
  }

  // 版权信息
  .footer-bottom {
    background: rgba(0, 0, 0, 0.3);
    padding: 20px 0;
    border-top: 1px solid rgba(255, 215, 0, 0.1);

    .container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;

      .copyright {
        p {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.6);
          margin: 0 0 5px 0;
        }

        .bottom-links {
          display: flex;
          align-items: center;
          gap: 15px;

          a {
            font-size: 14px;
            color: rgba(255, 255, 255, 0.6);
            text-decoration: none;
            transition: color 0.3s ease;

            &:hover {
              color: #ffd700;
            }

            &.icp-link {
              color: rgba(255, 255, 255, 0.6);
              
              &:hover {
                color: #ffd700;
              }
            }
          }

          .separator {
            color: rgba(255, 255, 255, 0.3);
          }
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 1024px) {
  .nav-footer {
    .container {
      grid-template-columns: 1fr 1fr;
      gap: 40px;
    }
  }
}

@media (max-width: 768px) {
  .nav-footer {
    .container {
      grid-template-columns: 1fr;
      gap: 40px;
      text-align: center;

      .footer-brand {
        .brand-logo {
          justify-content: center;
        }
      }

      .section-title {
        justify-content: center;
      }

      .brand-features {
        align-items: center;
      }
    }

    .footer-bottom {
      .container {
        flex-direction: column;
        gap: 15px;
        text-align: center;
      }
    }
  }
}

@media (max-width: 480px) {
  .nav-footer {
    .container {
      padding: 40px 15px 30px;
    }
  }
}
</style>